import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Slider,
    Typography,
    TextField
} from '@mui/material';
import { FiChevronDown } from 'react-icons/fi';

const MIN = 0;
const MAX = 5000;
const STEP = 50;

const PriceRange = ({ precoMin, precoMax, onChange, defaultExpanded = false }) => {
    const lower = precoMin ?? MIN;
    const upper = precoMax ?? MAX;
    const [localRange, setLocalRange] = React.useState([lower, upper]);

    React.useEffect(() => {
        setLocalRange([precoMin ?? MIN, precoMax ?? MAX]);
    }, [precoMin, precoMax]);

    const isActive = precoMin !== null || precoMax !== null;

    const commit = (next) => {
        const [a, b] = next;
        onChange({
            precoMin: a === MIN ? null : a,
            precoMax: b === MAX ? null : b
        });
    };

    const handleSlider = (_, value) => setLocalRange(value);

    const handleInput = (index) => (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        const value = raw === '' ? (index === 0 ? MIN : MAX) : Math.min(MAX, Math.max(MIN, Number(raw)));
        const next = [...localRange];
        next[index] = value;
        if (next[0] > next[1]) next[index] = next[1 - index];
        setLocalRange(next);
        commit(next);
    };

    return (
        <Accordion
            defaultExpanded={defaultExpanded}
            disableGutters
            elevation={0}
            sx={{
                bgcolor: 'transparent',
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                '&:before': { display: 'none' }
            }}
        >
            <AccordionSummary
                expandIcon={<FiChevronDown size={16} />}
                sx={{ px: 1.5, minHeight: 44, '& .MuiAccordionSummary-content': { my: 1 } }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, flex: 1 }}>
                        Faixa de preço
                    </Typography>
                    {isActive && (
                        <Box
                            sx={{
                                px: 0.75,
                                height: 18,
                                borderRadius: 9,
                                bgcolor: '#1a1a2e',
                                color: '#fff',
                                fontSize: 10,
                                fontWeight: 700,
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            ativo
                        </Box>
                    )}
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 2 }}>
                <Box sx={{ px: 1 }}>
                    <Slider
                        value={localRange}
                        onChange={handleSlider}
                        onChangeCommitted={(_, v) => commit(v)}
                        min={MIN}
                        max={MAX}
                        step={STEP}
                        size="small"
                        sx={{ color: '#1a1a2e' }}
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <TextField
                        label="Mín"
                        size="small"
                        value={localRange[0]}
                        onChange={handleInput(0)}
                        InputProps={{ sx: { fontSize: 12 } }}
                        InputLabelProps={{ sx: { fontSize: 12 } }}
                        sx={{ flex: 1 }}
                    />
                    <TextField
                        label="Máx"
                        size="small"
                        value={localRange[1]}
                        onChange={handleInput(1)}
                        InputProps={{ sx: { fontSize: 12 } }}
                        InputLabelProps={{ sx: { fontSize: 12 } }}
                        sx={{ flex: 1 }}
                    />
                </Box>
                <Typography sx={{ fontSize: 10, color: 'text.secondary', mt: 1 }}>
                    Filtro aplicado no servidor
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
};

export default PriceRange;
